import React from "react";
import {Modal, Tag, Tooltip} from "antd";
import {CheckCircleOutlined, CloseCircleOutlined, InfoCircleOutlined} from "@ant-design/icons";
import {ModalTableContainer} from "./NotificationContentModal.styles";
import {iOSDeviceModelIdentifiers, oneSignalNotificationTypes} from "constants/constants";

export const NotificationContentModal = ({visible, onClose, notification}) => {
    if (!notification) return null;

    const columns = [
        {
            title: "Cihaz Modeli",
            dataIndex: "deviceModel",
            width: 150,
            render: text => (
                <span data-label="Cihaz Modeli:">
                    {iOSDeviceModelIdentifiers[text] || text || "-"}
                </span>
            )
        },
        {
            title: "İşletim Sistemi Versiyonu",
            dataIndex: "deviceOs",
            width: 120,
            render: text => <span data-label="İşletim Sistemi Versiyonu:">{text || "-"}</span>
        },
        {
            title: "Aktiflik Durumu",
            dataIndex: "enabled",
            width: 100,
            render: enabled => (
                <span data-label="Aktiflik Durumu:">
                    {enabled ? (
                        <Tag icon={<CheckCircleOutlined />} color="success">
                            Aktif
                        </Tag>
                    ) : (
                        <Tag icon={<CloseCircleOutlined />} color="error">
                            Pasif
                        </Tag>
                    )}
                </span>
            )
        },
        {
            title: "Bildirim Türü",
            dataIndex: "collapseId",
            width: 150,
            render: text => (
                <span data-label="Bildirim Türü:">
                    {text ? (
                        <Tag color="blue">
                            {oneSignalNotificationTypes.find(type => type.value === text)?.label}
                        </Tag>
                    ) : (
                        "-"
                    )}
                </span>
            )
        },
        {
            title: "Açıklama",
            dataIndex: "description",
            width: 250,
            render: text => (
                <Tooltip title={text}>
                    <span
                        data-label="Açıklama:"
                        style={{
                            fontSize: "12px",
                            display: "block",
                            maxWidth: "250px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                        }}
                    >
                        {text || "-"}
                    </span>
                </Tooltip>
            )
        },
        {
            title: "Önerilen Aksiyon",
            dataIndex: "suggestion",
            width: 250,
            render: text => (
                <Tooltip title={text}>
                    <span
                        data-label="Önerilen Aksiyon:"
                        style={{
                            fontSize: "12px",
                            display: "block",
                            maxWidth: "250px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                        }}
                    >
                        {text ? (
                            <>
                                <InfoCircleOutlined style={{marginRight: 4}} />
                                {text}
                            </>
                        ) : (
                            "-"
                        )}
                    </span>
                </Tooltip>
            )
        }
    ];

    const subscriptions = notification?.oneSignalUserByExternalId?.subscriptions || [];
    const rawData = Array.isArray(subscriptions) ? subscriptions : Object.values(subscriptions);

    const dataSource = rawData.map((item, index) => ({
        ...item,
        uniqueKey: item._id || item.id || `subscription-${index}`
    }));

    return (
        <Modal
            title="Bildirim Abonelik Detayları"
            visible={visible}
            onCancel={onClose}
            footer={null}
            width={1200}
            style={{maxWidth: "95vw"}}
            bodyStyle={{padding: "12px"}}
        >
            <ModalTableContainer
                dataSource={dataSource}
                columns={columns}
                rowKey="uniqueKey"
                pagination={false}
                scroll={{x: "max-content"}}
            />
        </Modal>
    );
};
